import React, { useState } from "react";
import { postApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import CustomButton from "../../../../../components/Elements/Buttons/CustomButtons";
import { DailogBox } from "../../../../../components/Elements/DailogBox/DailogBox";
import TextStyles from "../../../../../components/Elements/TextStyles/TextStyles";

const CopyCustomerDynamicForm = ({
  onOpen,
  onClose,
  data,
  onSave,
  clientId,
  setShowSuccess,
  showPopup,
}) => {
  const [formName, setFormName] = useState("");
  const formId = data._id;

  const handleSave = async () => {
    try {
      const response = await postApi({
        apiUrl: API_URLS.COPY_CUSTOMER_DYNAMIC_FORM(formId),
        data: { title: formName },
        headers: { client: clientId },
      });

      if (response.success) {
        showPopup("success", "Success", "Dynamic Form Copied Successfully");
        await onSave();
      } else {
        showPopup("error", "Error", "Something went wrong.");
      }
    } catch (error) {
      showPopup("error", "Error", "Something went wrong.");
      console.error("Error in creating copy:", error);
    }
  };

  return (
    <>
      <div>
        <DailogBox
          open={onOpen}
          onCancel={onClose}
          width="90%"
          maxWidth="700px"
        >
          <TextStyles className="text-[#06513D]">
            CREATE COPY/ {data.title}
          </TextStyles>

          <div className=" my-8 py-8 border px-4 rounded-lg">
            <label className="my-4">Name</label>
            <input
              type={"secondary"}
              // label={"Name"}
              value={formName}
              placeholder="Name of Form"
              onChange={(e) => setFormName(e.target.value)}
              className="w-full border-b focus:outline-none px-1 font-light my-2"
            />
            <div className="text-center mt-8">
              <CustomButton
                type={"primary"}
                variant={"ok"}
                buttonText={"Save"}
                className={"w-32 py-5 text-[16px]"}
                onClick={handleSave}
              />
            </div>
          </div>
        </DailogBox>
      </div>
    </>
  );
};

export default CopyCustomerDynamicForm;
